<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5%">
	<div ngClass="p-l-xs">
		<img
			src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/WhyDonatesSVG/public"
		/>
	</div>

	<span
		i18n="@@footer_label_selectLanguage"
		class="footer-titles mat-headline-6"
		ngClass="p-l-xs"
	>
		Select Language
	</span>
	<div ngClass="p-l-xs">
		<app-language-chooser></app-language-chooser>
	</div>
	<span
		i18n="@@footer_label_followUs"
		class="footer-titles mat-headline-6"
		ngClass="p-l-xs"
		>Follow us</span
	>
	<div fxFlex="100" fxLayout="row wrap" fxLayoutAlign="start start ">
		<a
			target="_blank"
			class="insta"
			href="https://www.instagram.com/whydonate_official/"
		>
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/insta/public"
			/>
		</a>
		<a target="_blank" class="twitter" href="https://www.X.com/whydonate">
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/x/public"
			/>
		</a>
		<a
			target="_blank"
			class="linkedIn"
			href="https://www.linkedin.com/company/whydonate"
		>
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/linkedin/public"
			/>
		</a>
		<a
			target="_blank"
			class="facebook"
			href="https://www.facebook.com/whydonate"
		>
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fb/public"
			/>
		</a>
		<a
			target="_blank"
			class="facebook"
			href="https://www.youtube.com/channel/UCVAdWsKS2W2NEAyjsnCwqxw"
		>
			<img
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/youtubeNew1/public"
			/>
		</a>
		<a
			target="_blank"
			class="facebook"
			href="https://www.tiktok.com/@whydonate_official"
		>
			<img
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/tiktokNew1/public"
			/>
		</a>
	</div>
	<app-ratings fxFlex.gt-md="30%" fxFlex.gt-sm="18%"></app-ratings>
</div>
